import { useToastStore } from "../../stores/toastStore";
import { CheckCircle2, AlertCircle, Info, AlertTriangle, Undo2 } from "lucide-react";

export default function ToastHost() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container" role="status" aria-live="polite">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          role={toast.variant === "error" ? "alert" : "status"}
          className={`toast toast-${toast.variant} flex items-start gap-2.5 max-w-[360px]`}
        >
          <span className="flex items-center gap-2 flex-shrink-0 mt-0.5">
            {toast.variant === "success" && <CheckCircle2 size={16} />}
            {toast.variant === "error" && <AlertCircle size={16} />}
            {toast.variant === "info" && <Info size={16} />}
            {toast.variant === "warning" && <AlertTriangle size={16} />}
            {toast.variant === "undo" && <Undo2 size={16} />}
          </span>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold leading-snug">{toast.title}</p>
            {toast.description && (
              <p className="text-xs opacity-90 mt-0.5 leading-snug">{toast.description}</p>
            )}
          </div>
          {toast.action && (
            <button
              type="button"
              onClick={() => {
                dismiss(toast.id);
                toast.action!.onClick();
              }}
              className="toast-action flex items-center gap-1 text-xs font-bold uppercase tracking-wide hover:opacity-80 transition-opacity px-1 py-1 flex-shrink-0"
            >
              <Undo2 size={14} />
              {toast.action.label}
            </button>
          )}
          <button
            type="button"
            onClick={() => dismiss(toast.id)}
            aria-label="Cerrar notificación"
            className="toast-close text-sm leading-none opacity-70 hover:opacity-100 transition-opacity flex-shrink-0 px-0.5"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
